import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';

@Component({
  selector: 'sp-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
})
export class SearchFieldComponent {
  @Input() searchText = '';

  /** Placeholder */
  @Input() placeholder = '';

  /** Width */
  @Input() maxWidth = '';

  @Input() mobileSearch = false;

  @Input() attrDataTestId?: string; // data attribute id for test

  /** KeyupEvent*/
  @Output() keyUpInput = new EventEmitter<string>();

  // Clear Input
  @Output() clearInput = new EventEmitter<string>();

  // Toggle Mobile Search
  @Output() toggleMobileSearch = new EventEmitter<boolean>();

  @Output() addOnEnter = new EventEmitter();

  onKeyUp(value: string) {
    this.keyUpInput.emit(value);
  }

  clearSearch() {
    this.searchText = '';
    this.clearInput.emit(this.searchText);
  }

  toggleSearch() {
    this.toggleMobileSearch.emit(true);
  }

  hideMobileSearch(event: AnyType) {
    console.log(event);
  }
}
